'use client';

import { c as _c } from "react/compiler-runtime";
import { useMediaQuery } from 'usehooks-ts';
import { BREAKPOINTS_PX } from '../breakpoints';
const defaultBreakpoints = {
  sm: `${BREAKPOINTS_PX.sm}px`,
  md: `${BREAKPOINTS_PX.md}px`,
  lg: `${BREAKPOINTS_PX.lg}px`,
  xl: `${BREAKPOINTS_PX.xl}px`,
  '2xl': `${BREAKPOINTS_PX['2xl']}px`
};
function getBreakpoints() {
  if (typeof window === 'undefined' || !document?.documentElement) {
    return defaultBreakpoints;
  }
  const styles = getComputedStyle(document.documentElement);
  return {
    sm: styles.getPropertyValue('--breakpoint-sm') || defaultBreakpoints.sm,
    md: styles.getPropertyValue('--breakpoint-md') || defaultBreakpoints.md,
    lg: styles.getPropertyValue('--breakpoint-lg') || defaultBreakpoints.lg,
    xl: styles.getPropertyValue('--breakpoint-xl') || defaultBreakpoints.xl,
    '2xl': styles.getPropertyValue('--breakpoint-2xl') || defaultBreakpoints['2xl']
  };
}

// Start every query at `false` and read `matchMedia` after mount, so the first client render
// matches the server render (usehooks-ts 3 reads it during render by default).
const MEDIA_QUERY_OPTIONS = {
  initializeWithValue: false
};
export function useBreakpoints() {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getBreakpoints();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const breakpoints = t0;
  const isMobile = useMediaQuery(`(max-width: calc(${breakpoints.md} - 1px))`, MEDIA_QUERY_OPTIONS);
  const isTablet = useMediaQuery(`(min-width: ${breakpoints.md}) and (max-width: calc(${breakpoints.lg} - 1px))`, MEDIA_QUERY_OPTIONS);
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.lg}) and (max-width: calc(${breakpoints["2xl"]} - 1px))`, MEDIA_QUERY_OPTIONS);
  const isLargeDesktop = useMediaQuery(`(min-width: ${breakpoints["2xl"]})`, MEDIA_QUERY_OPTIONS);
  const isSmUp = useMediaQuery(`(min-width: ${breakpoints.sm})`, MEDIA_QUERY_OPTIONS);
  const isMdUp = useMediaQuery(`(min-width: ${breakpoints.md})`, MEDIA_QUERY_OPTIONS);
  const isLgUp = useMediaQuery(`(min-width: ${breakpoints.lg})`, MEDIA_QUERY_OPTIONS);
  const isXlUp = useMediaQuery(`(min-width: ${breakpoints.xl})`, MEDIA_QUERY_OPTIONS);
  const is2xlUp = useMediaQuery(`(min-width: ${breakpoints["2xl"]})`, MEDIA_QUERY_OPTIONS);
  const breakPointArray = [isMobile, isTablet, isDesktop, isLargeDesktop];
  const currentBreakpointIndex = breakPointArray.findIndex(_temp);
  let t1;
  if ($[1] !== currentBreakpointIndex) {
    t1 = function rv(...t2) {
      const values = t2;
      return values[currentBreakpointIndex];
    };
    $[1] = currentBreakpointIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rv = t1;
  let t2;
  if ($[3] !== is2xlUp || $[4] !== isDesktop || $[5] !== isLargeDesktop || $[6] !== isLgUp || $[7] !== isMdUp || $[8] !== isMobile || $[9] !== isSmUp || $[10] !== isTablet || $[11] !== isXlUp || $[12] !== rv) {
    t2 = {
      isMobile,
      isTablet,
      isDesktop,
      isLargeDesktop,
      isSmUp,
      isMdUp,
      isLgUp,
      isXlUp,
      is2xlUp,
      rv
    };
    $[3] = is2xlUp;
    $[4] = isDesktop;
    $[5] = isLargeDesktop;
    $[6] = isLgUp;
    $[7] = isMdUp;
    $[8] = isMobile;
    $[9] = isSmUp;
    $[10] = isTablet;
    $[11] = isXlUp;
    $[12] = rv;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}
function _temp(is) {
  return is;
}